<template>
    <div>
        <Card>
            <p slot="title">
                User
            </p>
            <Button type="primary" slot="extra" @click="toggleForm()" size="small">
                Tambah
            </Button>
            <template>
              <Modal v-model="showForm" width="30%">
                <Card v-show="showForm">
                    <Form ref="formUser" :model="formUser" :rules="ruleValidate">
                        <Form-item label="Username" prop="username">
                            <Input v-model="formUser.username" placeholder="Username"></Input>
                        </Form-item>
                        <Form-item label="Password" prop="password">
                            <Input v-model="formUser.password" placeholder="Password"></Input>
                        </Form-item>
                        <Form-item label="Role" prop="role">
                            <Select v-model="formUser.role">
                                <Option v-for="item in roles" :value="item.value" :key="item.value">{{ item.label }}
                                </Option>
                            </Select>
                        </Form-item>
                        <Form-item label="Branchcode" prop="branchcode">
                            <Select v-model="formUser.branchcode">
                                <Option v-for="item in branchcode" :value="item.value" :key="item.id">{{ item.label
                                    }}</Option>
                            </Select>
                        </Form-item>
                        <Form-item label="Country" prop="Country">
                            <Select v-model="formUser.country">
                                <Option v-for="item in country" :value="item.value" :key="item.id">{{ item.label
                                    }}</Option>
                            </Select>
                        </Form-item>
                        <Form-item label="Divisions" prop="divisions">
                            <Select placeholder="Ketik Division" v-model="formUser.divisions" filterable multiple
                                :remote-method="getDivision" :loading="loadingGetDivision">
                                <Option v-for="(option, index) in optionDivisions" :value="option.value" :key="index">
                                    {{ option.label }}</Option>
                            </Select>
                        </Form-item>
                        <Form-item>
                            <Button type="success" @click="handleSubmit('formUser')">Save</Button>
                        </Form-item>
                    </Form>
                </Card>
               </Modal>
                <br />
                <Table border :columns="columnTableUser" :data="users"></Table>

            </template>

        </Card>
        <template>
            <Modal v-model="modal.userUpdate" width="500px">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Reset Password</span>
                </p>
                <Form ref="formUserUpdate" :model="formUserUpdate" :rules="ruleValidateUserUpdate">
                    <Form-item label="Username" prop="username">
                        <Input style="display: none;" v-model="formUserUpdate.id" placeholder="User Id"></Input>
                        <Input v-model="formUserUpdate.username" placeholder="Username" disabled></Input>
                    </Form-item>
                    <Form-item label="Role" prop="role">
                        <Select v-model="formUserUpdate.role">
                            <Option v-for="item in roles" :value="item.value" :key="item.value">{{ item.label }}
                            </Option>
                        </Select>
                    </Form-item>
                    <Form-item label="Branchcode" prop="branchcode">
                        <Select v-model="formUserUpdate.branchcode">
                            <Option v-for="item in branchcode" :value="item.value" :key="item.id">{{ item.label }}
                            </Option>
                        </Select>
                    </Form-item>
                     <Form-item label="Country" prop="country">
                        <Select v-model="formUserUpdate.country">
                            <Option v-for="item in country" :value="item.value" :key="item.id">{{ item.label }}
                            </Option>
                        </Select>
                    </Form-item>
                    <Form-item label="Divisions" prop="divisions">
                        <Select placeholder="Ketik Division" v-model="formUserUpdate.divisions" filterable multiple
                            :remote-method="getDivision" :loading="loadingGetDivision">
                            <Option v-for="(option, index) in optionDivisions" :value="option.value" :key="index">
                                {{ option.label }}</Option>
                        </Select>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button v-show="true" type="primary" :loading="loadingUserUpdate" @click="postUserUpdate">
                        <span v-if="!loadingUserUpdate">Edit</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
        <template>
            <Modal v-model="modal.userResetPassword" width="500px">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Reset Password</span>
                </p>
                <Form ref="formUserResetPassword" :model="formUserResetPassword" :rules="ruleValidateUserResetPassword">
                    <Form-item label="Username" prop="username">
                        <Input style="display: none;" v-model="formUserResetPassword.id" placeholder="User Id"></Input>
                        <Input v-model="formUserResetPassword.username" placeholder="Username" disabled></Input>
                    </Form-item>
                    <Form-item label="Password" prop="password">
                        <Input v-model="formUserResetPassword.password" type="password" placeholder="Password"></Input>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button v-show="formUserResetPassword.password.length > 5" type="error"
                        :loading="loadingUserResetPassword" @click="postUserResetPassword">
                        <span v-if="!loadingUserResetPassword">Reset</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'

export default {
    data() {
        return {
            modal: {
                userResetPassword: false,
                userUpdate: false,
            },
            formUserResetPassword: {
                username: '',
                password: '',
            },
            formUserUpdate: {
                username: '',
                branchcode: '',
                role: '',
                country: '',
                divisions: []
            },
            loadingUserResetPassword: false,
            loadingUserUpdate: false,
            loadingSearch: false,
            loadingGetDivision: false,
            showForm: false,
            users: [],
            roles: [
                { value: 'ADMIN', label: 'Admin' },
                { value: 'ADMIN-DEPOSIT', label: 'Admin Deposit' },
                { value: 'PRINT', label: 'Print' },
                { value: 'STAFF', label: 'Staff' },
                { value: 'SUPERVISOR', label: 'Supervisor' },
                { value: 'SUPERVISOR-SBY', label: 'Supervisor Surabaya' },
                { value: 'KONTRA', label: 'Kontra' },
                { value: 'SURAT-JALAN', label: 'Surat Jalan' },
                { value: 'SURAT-JALAN-PIUTANG', label: 'Surat Jalan Piutang' },
                { value: 'ADMINISTRATOR', label: 'Administrator' },
                { value: 'VIEW-ONLY', label: 'View only' },
                { value: 'ADMIN-SUPER', label: 'Admin Super'}
            ],
            branchcode: [],
            country: [],
            formUser: {
                username: '',
                password: '',
                role: '',
                branchcode: '',
                country: '',
                divisions: [],
            },
            ruleValidate: {
                username: [
                    { required: true, message: 'Masukkan Username', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'Masukkan Password', trigger: 'blur' }
                ],
                role: [
                    { required: true, message: 'Pilih Role', trigger: 'change' }
                ],
                gender: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ]
            },
            ruleValidateUserResetPassword: {
                password: [
                    { required: true, message: 'Masukkan Password', trigger: 'blur' }
                ]
            },
            ruleValidateUserUpdate: {
                role: [
                    { required: true, message: 'Pilih Role', trigger: 'change' }
                ]
            },
            columnTableUser: [
                {
                    title: 'Username',
                    key: 'username'
                },
                {
                    title: 'Role',
                    key: 'role'
                },
                {
                    title: 'Divisions',
                    key: 'divisionName'
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 250,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showUserUpdate(params.index)
                                    }
                                }
                            }, 'Edit'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.showUserResetPassword(params.index)
                                    }
                                }
                            }, 'Reset Password')
                        ]);
                    }
                }
            ],
            optionDivisions: [],
        }
    },
    methods: {
        showUserResetPassword: function (index) {
            var userId = this.users[index].id;
            this.formUserResetPassword.id = userId;

            var username = this.users[index].username;
            this.formUserResetPassword.username = username;

            this.formUserResetPassword.password = '';
            this.modal.userResetPassword = true;
        },
        postUserResetPassword: function () {
            HTTP
                .post('user/resetPassword', {
                    id: this.formUserResetPassword.id,
                    password: this.formUserResetPassword.password,
                })
                .then(response => {
                    this.formUserResetPassword.username = '';
                    this.formUserResetPassword.password = '';
                    this.modal.userResetPassword = false;

                    this.$Message.success('Password Updated!');
                    this.getUsers();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showUserUpdate: function (index) {
            var userId = this.users[index].id;
            this.formUserUpdate.id = userId;

            var username = this.users[index].username;
            this.formUserUpdate.username = username;

            var role = this.users[index].role;
            this.formUserUpdate.role = role;

            var branchcode = this.users[index].subbranchcode;
            this.formUserUpdate.branchcode = branchcode;

            var country = this.users[index].country;
            this.formUserUpdate.country = country;

            let divisions = this.users[index].divisions.map(value => {
                return {
                    label: value.division_name,
                    value: value.id
                }
            })
            this.formUserUpdate.divisions = divisions.map(value => value.value)
            this.optionDivisions = divisions
            this.modal.userUpdate = true;
        },
        postUserUpdate: function () {

            var branchcode = this.formUserUpdate.branchcode;

            if (branchcode != 'JKT' || branchcode != 'MDN') {
                branchcode = 'JKT';
            }

            HTTP
                .post('user/update', {
                    id: this.formUserUpdate.id,
                    role: this.formUserUpdate.role,
                    branchcode: branchcode,
                    subbranchcode: this.formUserUpdate.branchcode,
                    country: this.formUserUpdate.country,
                    divisions: this.formUserUpdate.divisions,
                })
                .then(response => {
                    this.formUserUpdate.username = '';
                    this.formUserUpdate.role = '';
                    this.formUserUpdate.branchcode = '';
                    this.formUserUpdate.country = '';
                    this.modal.userUpdate = false;

                    this.$Message.success('User Updated!');
                    this.getUsers();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        toggleForm: function () {

            if (this.showForm) {
                this.showForm = false;
            } else {
                this.showForm = true;
            }
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.createuser();
                } else {
                    this.$Message.error('Data masih belum lengkap');
                }
            })
        },

        getUsers: function () {
            this.loadingSearch = true;
            this.users = []
            let userList = []

            HTTP
                .get('user/list')
                .then(response => {
                    this.loadingSearch = false;

                    _.forEach(response.data, function (value) {
                        let divisionName = value.divisions.length != 0 ? value.divisions.map(({ division_name }) => division_name).join(', ') : '';

                        let user = {
                            id: value.id,
                            username: value.username,
                            branchcode: value.branchcode,
                            subbranchcode: value.subbranchcode,
                            role: value.role,
                            country: value.country,
                            divisionName: divisionName,
                            divisions: value.divisions
                        }

                        userList.push(user);
                    });

                    this.users = userList
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        createuser: function () {
            let userExist = _.some(this.users, { username: this.formUser.username });

            if (userExist) {
                this.$Message.error('User sudah ada');
                return false;
            }

            let branchcode = this.formUser.branchcode;
            let subbranchcode = this.formUser.branchcode;

            if (branchcode == 'SBY') {
                branchcode = 'JKT';
            }

            HTTP
                .post('user/create', {
                    username: this.formUser.username,
                    password: this.formUser.password,
                    role: this.formUser.role,
                    branchcode: branchcode,
                    subbranchcode: subbranchcode,
                    country: this.formUser.country,
                    divisions: this.formUser.divisions
                })
                .then(response => {

                    this.formUser.username = '';
                    this.formUser.password = '';
                    this.formUser.role = '';
                    this.showForm = false;

                    this.$Message.success('User Created');
                    this.getUsers();
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getDivision: function () {
            this.loadingGetDivision = true;
            this.optionDivisions = [];

            HTTP
                .post('division/list')
                .then(response => {
                    this.loadingGetDivision = false
                    let divisions = response.data.map(function (value) {
                        return {
                            value: value.id,
                            label: value.division_name
                        }
                    })
                    this.optionDivisions = divisions
                }).catch(err => {
                    this.loadingGetDivision = false
                    this.$Notice.error({
                        title: "Error",
                        desc: err,
                        duration: 5
                    });
                })

        },
        getBranch: function () {
            HTTP
                .get('subbranch')
                .then(response => {
                    this.branchcode = response.data.map(value => {
                        return {
                            id: value.id,
                            value: value.subbranchcode,
                            label: value.subbranchname
                        }
                    })
                })
                .catch(err => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getCountry: function () {
            HTTP
                .get('country')
                .then(response => {
                    this.country = response.data.map(value => {
                        return {
                            id: value.id,
                            value: value.country,
                            label: value.country
                        }
                    })
                })
                .catch(err => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
    },
    mounted() {
    },
    created() {
        this.getUsers();
        this.getBranch();
        this.getCountry();
    }
}
</script>
<style></style>



// WEBPACK FOOTER //
// User.vue?484240d5